export default __webpack_public_path__ + "static/media/iconJob.11ed6266.svg";